import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { storyblokEditable } from '@storyblok/react';
import React, { memo } from 'react';
import { withBaseComponent } from '../hoc/withBaseComponent';

const StoryblokChipComponent = ({ blok, baseStyles }) => {
  const { general = { label: 'Chip' }, extra = { id: '' } } = blok;
  const { id } = extra;
  const { label } = general;

  return (
    <Box
      id={id}
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ ...baseStyles }}>
        <Chip
          {...storyblokEditable(blok)}
          label={label.toUpperCase()}
          sx={{ border: '2px solid #FAFAFA', color: 'primary' }}
        />
      </Box>
    </Box>
  );
};

StoryblokChipComponent.displayName = 'StoryblokChip';
const StoryblokChip = withBaseComponent(StoryblokChipComponent);

export default memo(StoryblokChip);
